export const TREATMENTS = {
    ENDOMETRIOSIS: "endometriosis",
    PCOS: "pcos",
    POSTPARTUM: "postpartum",
    PERIMENOPAUSE: "perimenopause",
    MENOPAUSE: "menopause",
} as const;

export type TREATMENT = (typeof TREATMENTS)[keyof typeof TREATMENTS]